import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useMailTemplateDetail = (id: number, mail_type: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [tmpplateInfo, setTemplateInfo] = useState<MailTemplateDto>();
  
  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading, refetch } = useQuery(
    [endpoints.mailtemplate.info, mail_type],
    () =>
      fetcher.mailtemplate.postMailTemplateInfo({
        id: id,
        mail_type: mail_type,       
      }),
    {
      enabled: mail_type !== '',
      onSuccess: (res: MailTempalteInfoResDto) => {
        switch (res.code) {
          case 200:
            setTemplateInfo(res.result?.info);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: mailTemplateInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.mailtemplate.add],
    fetcher.mailtemplate.postMailTemplateAdd,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: mailTemplateSave, isSuccess: updateSuccess } = useMutation(
    [endpoints.mailtemplate.update],
    fetcher.mailtemplate.postMailTemplateSave,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )
  
  const { mutate: mailTemplateDelete, isSuccess: deleteSuccess } = useMutation(
    [endpoints.mailtemplate.add],
    fetcher.mailtemplate.postMailTemplateDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { isLoading, tmpplateInfo, refetch, mailTemplateInsert, mailTemplateSave, mailTemplateDelete, insertSuccess, updateSuccess, deleteSuccess };
};

export default useMailTemplateDetail;
